import { FC } from 'react';

import { OldPrice } from './OldPrice';
import { Price } from './Price';

type Props = { price: string | number; oldPrice: string | number };

export const PriceTag: FC<Props> = ({ price, oldPrice }) => (
    <span>
        <Price>{price}</Price> <OldPrice>{oldPrice}</OldPrice>
    </span>
);
